import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionDspComponent } from './section-dsp.component';


@NgModule({
  declarations: [SectionDspComponent],
  exports: [SectionDspComponent],
  imports: [
    CommonModule
  ]
})
export class SectionDspModule { }
